import { ref, computed } from 'vue'
import { useHttp } from '@core/composables/useHttp'
import { useOrder } from '@core/composables/order/useOrder'
import { OrderTypes } from '@modules/app-steps/step-two/tabs/tabs-data'
import { useNavigationButtons } from '@modules/app-steps/step-two/navigation-buttons'
import { BILLING_PAGE_TAB_VALUE, useTabsStore } from '@/stores/tabs'
import { storeToRefs } from 'pinia'

import moment from 'moment'
import API from '@core/api.js'

const clientCredits = ref(null)
const total = ref(0)
const lastPage = ref(0)
const currentPage = ref(1)
const isClientCreditsExists = computed(() => {
  return (clientCredits.value && !!clientCredits.value?.data?.length) ?? false
})

const totalCredits = computed(() => clientCredits.value?.total)
const isExpired = (expirationDate) => {
  const now = moment()
  const expirationTime = moment(expirationDate)
  const diff = expirationTime.diff(now, 'days')

  return diff < 0
}

const { data, isLoading: isClientCreditsLoading, execute } = useHttp()

const changePage = (page) => (currentPage.value = page)

const useClientCredits = () => {
  const { useUpdateOrder } = useOrder()

  const { isLoading, updateOrder } = useUpdateOrder()

  const handleCredit = (payload) => {
    return new Promise((resolve, reject) => {
      updateOrder(
        payload,
        () => {
          // setOrderType(payload.orderType)
          resolve()
        },
        () => reject()
      )
    })
  }

  const purchaseCreditExtension = (clientCreditsId) => {
    handleCredit({
      clientCreditsId,
      orderType: OrderTypes.CreditExtension,
      metadata: { currentTab: BILLING_PAGE_TAB_VALUE },
    })
  }

  const redeemCredit = async (clientCreditsId) => {
    return handleCredit({
      clientCreditsId,
      orderType: OrderTypes.RedeemedCredit,
    })
  }

  const getClientCredits = (payload) =>
    execute({ url: API.clientCreditsResource, ...payload }, () => {
      clientCredits.value = data.value
      total.value = data.value.meta?.total
      lastPage.value = data.value.meta?.lastPage
    })

  return {
    clientCredits,
    totalCredits,
    isExpired,
    isClientCreditsExists,
    isClientCreditsLoading,
    isOrderUpdating: isLoading,
    getClientCredits,
    purchaseCreditExtension,
    redeemCredit,
  }
}

export {
  total,
  lastPage,
  currentPage,
  changePage,
  isClientCreditsExists,
  useClientCredits,
}
